import * as ActionTypes from "constants/ActionTypes";
import fetch from "isomorphic-fetch";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { delay } from "redux-saga";
import { storyId } from "selectors/story/getStoryId";

function* closeUserNotification() {
  yield put({
    type: ActionTypes.CLOSE_USER_NOTIFIER,
    message: "",
    title: "",
  });
}

function* showAbuseConfirmation() {
  const id = yield select(storyId);
  yield fetch(`/api/v1/stories/${id}/report_abuse/`);
  yield put({
    type: ActionTypes.SHOW_USER_NOTIFIER,
    title: "Report Abuse",
    message: "The story has been reported.",
  });
  yield delay(4000);
  yield call(closeUserNotification);
}

function* showUserNotification(shareState) {
  yield put({
    type: ActionTypes.SHOW_USER_NOTIFIER,
    message: shareState.shareType,
    title: "Successful share",
  });
  yield delay(4000);
  yield call(closeUserNotification);
}

export default function* controlNotifications() {
  yield takeLatest(
    ActionTypes.USER_INTERACTION_REPORT_ABUSE,
    showAbuseConfirmation,
  );
  yield takeLatest(ActionTypes.USER_SHARED_STORY, showUserNotification);
}
